
































































import { BasicProductV2 as BasicProduct } from '@master/model/kyc-form/product/BasicProductV2'
import { Component, Vue, Prop } from 'vue-property-decorator'
import { convertToCurrencyFormat } from '@core/tools/Formatter'
import { inject } from 'inversify-props'
import { IProjectInfo } from '@master/config/IProjectInfo'

export interface CardStructure {
  summary: Element<BasicProduct>[];
  details: Element<BasicProduct>[];
  subList: Element<BasicProduct>[];
}

interface Element<T> {
  label: string;
  key: keyof T;
  type?: string;
}

@Component
export default class TheProductCard extends Vue {
  @Prop() rcmdList: BasicProduct[]
  @Prop() formStructure: CardStructure
  @Prop() cardType: 'insurance' | 'investment' | 'uncategorised'
  @Prop({ default: 'one-column' }) cardDisplayInColumn: 'one-column' | 'two-column'
  @Prop() customCardHeader?: string

  @inject()
  private projectInfo: IProjectInfo

  get subProductTitle () {
    if (this.cardType === 'insurance') {
      return 'Riders'
    }
    return 'Funds'
  }

  getSubProduct (mainProduct) {
    if (this.cardType === 'insurance') {
      return mainProduct?.riders
    }
    return mainProduct?.investmentFunds
  }

  toggleExpand (key) {
    const element = document
      .getElementById(key)
      .getElementsByClassName('detail')[0]
    const classList = element.classList
    if (classList.contains('active')) {
      classList.remove('active')
      classList.add('inactive')
    } else {
      classList.add('active')
      classList.remove('inactive')
    }
  }

  getDetail (plan, summaryElement) {
    if (summaryElement.value) {
      return summaryElement.value
    }
    const value = plan[summaryElement.key]
    if (!value) return
    if (summaryElement.type === 'currency') {
      return convertToCurrencyFormat(value, this.projectInfo.currency)
    }
    return value.toString()
  }

  deleteProduct (product: BasicProduct) {
    this.$emit('delete', { product: product })
  }

  editProduct (plan, cardType) {
    this.$emit('edit', { product: plan, type: cardType })
  }
}

